module.exports = __webpack_public_path__ + "img/3-gallery.f6df4792.jpg";